// src/data/services.ts
import { CompanyService } from "../types/services";

export const netcomServices: CompanyService[] = [
  {
    id: "ms-ent",
    category: "Enterprise",
    title: "Microsoft Solutions",
    description:
      "Specialized design and deployment of Active Directory, Exchange Server, Lync, and SharePoint for seamless collaboration.",
    features: ["User Management", "Webmail", "Messaging"],
    technologies: ["Active Directory", "Exchange", "Lync", "SharePoint"],
    icon: "Terminal",
  },
  {
    id: "net-sec",
    category: "Infrastructure",
    title: "Network & Security",
    description:
      "Planning and deploying data centers with Cisco security, Cyberoam, and high-end application servers for data protection.",
    features: ["Data Center Design", "Security Audits"],
    technologies: ["Cisco", "Cyberoam", "Servers"],
    icon: "Router",
  },
  {
    id: "web-mob",
    category: "Development",
    title: "Web & Mobile Apps",
    description:
      "High scalability applications designed for mobile compatibility and live migration into cloud environments.",
    features: ["Android Dev", "Scalable Web", "Cloud Migration"],
    technologies: ["Java", "PHP", "Ruby", "Android", "Linux"],
    icon: "Phonelink",
  },
];
